import { initialState } from './initial';
import { actionTypes } from './actions';

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING:
      return {
        ...state,
        actionProcessing: action.payload?.[actionTypes.ACTION_PROCESSING],
      };

    case actionTypes.IS_OPENED:
      return {
        ...state,
        isOpened: action.payload?.[actionTypes.IS_OPENED],
      };

    case actionTypes.TABLE_INFO:
      return {
        ...state,
        rows: action.payload?.[actionTypes.TABLE_INFO]?.rows,
        columns: action.payload?.[actionTypes.TABLE_INFO]?.columns,
        tableType: action.payload?.[actionTypes.TABLE_INFO]?.type,
      };

    case actionTypes.TABLE_CLEAR:
      return { ...state, rows: [], columns: [], tableType: null };

    case actionTypes.PARSED_MESSAGE:
      return {
        ...state,
        parsedMessage: action.payload?.[actionTypes.PARSED_MESSAGE],
      };

    default:
      return { ...state };
  }
};
